// ヘッダーバー。
//
// 役割: アプリ名、DuckDB+Spatial の起動状態バッジ（plan.md §4.1）、左右パネルの開閉トグル、
//       右側に設定スロット（ApiSettings）を表示する。
// 関係: status は App が DuckDB 起動 smoke test の結果として渡す
//       （'initializing' | 'ready' | 'error'）。leftOpen/rightOpen と onToggleLeft/onToggleRight で
//       管理パネル・エージェントパネルの表示を切り替える。
//
// status バッジは起動可否を一目で示し、error 時は SQL/取込 UI を無効化する判断材料になる。
function Header({
  status,
  errorMessage,
  settingsSlot,
  leftOpen,
  rightOpen,
  onToggleLeft,
  onToggleRight,
  onShowAbout,
}) {
  return (
    <header className="app-header">
      <button
        type="button"
        className={`panel-toggle${leftOpen ? ' active' : ''}`}
        aria-pressed={leftOpen}
        onClick={onToggleLeft}
        title="管理パネルの表示/非表示"
      >
        ◧<span className="btn-label"> 管理</span>
      </button>

      <div className="app-title">
        🌐<span className="title-text"> web-gis-ai-agent</span>
      </div>

      <button
        type="button"
        className="panel-toggle"
        onClick={onShowAbout}
        title="このサイトについて"
      >
        ⓘ<span className="btn-label"> About</span>
      </button>

      <div className={`duckdb-badge ${status}`} title={errorMessage || ''}>
        ●
        <span className="badge-text">
          {status === 'initializing' && ' DuckDB 起動中…'}
          {status === 'ready' && ' Spatial OK'}
          {status === 'error' && ' 起動失敗'}
        </span>
      </div>

      <div className="header-spacer" />

      <button
        type="button"
        className={`panel-toggle${rightOpen ? ' active' : ''}`}
        aria-pressed={rightOpen}
        onClick={onToggleRight}
        title="エージェントパネルの表示/非表示"
      >
        <span className="btn-label">エージェント </span>◨
      </button>

      {settingsSlot}
    </header>
  )
}

export default Header
